import styled from '@emotion/styled';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import { ContentLayout } from '@shared/components/core/text/ContentTypography';
import { FieldLabel } from '@shared/components/core/text/FormsTypography';
import MacroListing from '@shared/components/macro/MacroListing';
import AssociatedProgramsListing from '@shared/components/profile/listing/AssociatedProgramsListing';
import HotkeysListing from '@shared/components/profile/listing/HotkeysListing';
import KeyCommandListing from '@shared/components/profile/listing/KeyCommandsListing';
import { CommandType } from '@shared/constants/CommandValues';
import { useEditProfileStore } from '@shared/hooks/state/EditProfileContainer';
import useFilterProfileConfigurations from '@shared/hooks/useFilteredProfileConfigurations';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ProfileSummaryPageContent() {
    const { t } = useTranslation();
    const associatedPrograms = useEditProfileStore((state) => state.associatedPrograms);
    const name = useEditProfileStore((state) => state.name);
    const [selectedCommandType, setSelectedCommandType] = useState<CommandType | ''>('');
    const [filter, setFilter] = useState<string>('');
    const { filteredMacros, filteredHotkeys, filteredKeybinds } = useFilterProfileConfigurations({
        profile: useEditProfileStore.getState(),
        filter: filter,
        selectedCommandType: selectedCommandType || undefined,
    });
    return (
        <>
            <ContentLayout>
                <FormControl fullWidth style={{ marginTop: 32 }}>
                    <InputLabel id="command-type">{t('common:input.filter')}</InputLabel>
                    <Select
                        labelId={`command-type`}
                        value={selectedCommandType}
                        label={t('common:input.filter')}
                        onChange={(e) => setSelectedCommandType(e.target.value as CommandType)}>
                        <MenuItem value={''}>{t('common:all')}</MenuItem>
                        <MenuItem value="other">{t('common:voice.title')}</MenuItem>
                        <MenuItem value="expression">{t('common:expression.title')}</MenuItem>
                        <MenuItem value="tilt">{t('common:motion.title')}</MenuItem>
                        <MenuItem value="external_keyboard">{t('common:hotkey.title')}</MenuItem>
                    </Select>
                    <FieldLabel htmlFor={`filter`}>{t('common:profile.summary.filter')}</FieldLabel>
                    <StyledTextField
                        value={filter ?? ''}
                        name={`filter`}
                        placeholder={t('common:profile.summary.placeholder')}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </FormControl>
            </ContentLayout>
            <ListingContentWrapper>
                <MacroListing macros={filteredMacros} startExpanded={true} />
                <KeyCommandListing commandKeyMappings={filteredKeybinds} showDescription={false} />
                <HotkeysListing hotkeys={filteredHotkeys} showDescription={false} />
                <AssociatedProgramsListing
                    programNames={associatedPrograms}
                    profileName={name}
                    showDescription={false}
                />
            </ListingContentWrapper>
        </>
    );
}

const ListingContentWrapper = styled.div`
    margin: 0 2rem;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
